import { useEffect, useState } from 'react';
import type { ProjectDto } from '@ederest/contracts';
import { useProjects } from './queries.js';

const STORAGE_KEY = 'ederest.activeProject';

/** The active project drives every screen; it survives a reload. */
export function useActiveProject() {
  const { data: projects = [], isLoading } = useProjects();
  const [activeId, setActiveId] = useState<string | null>(() => localStorage.getItem(STORAGE_KEY));

  useEffect(() => {
    if (projects.length === 0) return;
    const known = projects.some((project) => project.id === activeId);
    if (!known) {
      const fallback = projects[0]!.id;
      setActiveId(fallback);
      localStorage.setItem(STORAGE_KEY, fallback);
    }
  }, [projects, activeId]);

  const select = (id: string) => {
    setActiveId(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  const project: ProjectDto | undefined = projects.find((candidate) => candidate.id === activeId);
  return { project, projects, select, isLoading };
}
